import { render, staticRenderFns } from "./editor-templates.vue?vue&type=template&id=2c5b224f&scoped=true&"
import script from "./editor-templates.vue?vue&type=script&lang=js&"
export * from "./editor-templates.vue?vue&type=script&lang=js&"
import style0 from "./editor-templates.vue?vue&type=style&index=0&id=2c5b224f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b224f",
  null
  
)

export default component.exports